import { Collapse, Icon } from '@material-ui/core';
import MyTable, { MyTableBody, MyTableCol, MyTableHeader, MyTableRow } from 'components/MyTable';
import { WithStyles } from 'decorators/withStyles';
import React, { Fragment, PureComponent } from 'react';
import { FormattedNumber } from 'react-intl';

import TableSubItem from './SubItem';

import type { IMyTableHeaderIndex } from 'components/MyTable/MyTableHeader';
import type { ICDFList } from 'store/Orbita/FiscalDocuments/interfaces';

interface IState {
  collapsed: boolean;
  headers: IMyTableHeaderIndex[];
}

interface IProps {
  numHeaders: number;
  data: ICDFList[0];

  classes?: any;
}

@WithStyles({
  tr: {
    cursor: 'pointer',
  },
  tdAction: {
    textAlign: 'right',
    width: 50,
    paddingRight: '12px !important',
  },
  tableCollapse: {
    padding: '0 !important',
  },
})
export default class TableItem extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      collapsed: true,
      headers: [
        { title: 'Data' },
        { title: 'Código' },
        { title: 'Status' },
        { title: 'Nome - Documento' },
        { title: 'Valor', numeric: true },
        { title: '' },
      ],
    };
  }

  toogleCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  getTotal = (item: any) => {
    let totalValue = 0;
    if (item && Array.isArray(item)) {
      let result = item.reduce((acc: any, i: any) => acc + i.value, 0);
      totalValue = totalValue + result;
    }
    return totalValue;
  };

  render() {
    const { collapsed, headers } = this.state;
    const { data, classes, numHeaders } = this.props;

    return (
      <Fragment>
        <MyTableRow className={classes.tr} onClick={this.toogleCollapse}>
          <MyTableCol>{data.date}</MyTableCol>
          <MyTableCol numeric>{data.list.length}</MyTableCol>
          <MyTableCol numeric>
            <FormattedNumber value={this.getTotal(data.list)} format='BRL' />
          </MyTableCol>
          <MyTableCol className={classes.tdAction}>
            <Icon>{collapsed ? 'expand_more' : 'expand_less'}</Icon>
          </MyTableCol>
        </MyTableRow>

        <MyTableRow>
          <MyTableCol colSpan={numHeaders} className={classes.tableCollapse}>
            <Collapse in={!collapsed}>
              <MyTable>
                <MyTableHeader index={headers} />
                <MyTableBody>
                  {!(data.list || []).length && (
                    <tr>
                      <td colSpan={headers.length} className={classes.emptyMessage}>
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}
                  {(data.list || []).map((item) => (
                    <TableSubItem key={item.id} data={item} />
                  ))}
                </MyTableBody>
              </MyTable>
            </Collapse>
          </MyTableCol>
        </MyTableRow>
      </Fragment>
    );
  }
}
